
import { Usr_Log } from 'src/app/shared/models/usr_log';
import { DBSeq } from 'src/app/shared/models/objects/dbseq';
import { CommonEnums } from 'src/app/shared/common.enums';
import { NavigateUtil } from 'src/app/shared/utils/navigate.util';
import { SeqGridObject } from 'src/app/shared/models/beans/seqgridobject';
import { Util } from 'src/app/shared/utils/util';
import { DatabaseWrappersFactory } from 'src/app/shared/databases/database.wrappers.factory';

export class DBSeqUtil {
    private static instance: DBSeqUtil;

    static getInstance() {
        if (!DBSeqUtil.instance) {
            DBSeqUtil.instance = new DBSeqUtil();
        }

        return DBSeqUtil.instance;
    }

    /**
     * DBSeqUtil is a singleton class, so use DBSeqUtil.getInstance() method instead of creating new DBSeqUtil().
     */
    private constructor() {

    }

    getUsr_Log(dBSeq: DBSeq): Usr_Log {
        let usr_Log: Usr_Log = new Usr_Log();

        usr_Log.obj_Cd = CommonEnums.codes.DBSEQ;
        usr_Log.obj_Id = dBSeq.native_Db_Seq.native_Db_Seq_Id;
        usr_Log.nm = dBSeq.native_Db_Seq.nm;
        usr_Log.objectName = "Sequence";
        usr_Log.imageUrl = 'assets/' + dBSeq.imageUrl.slice(4, dBSeq.imageUrl.length);
        usr_Log.valid_Cd = dBSeq.native_Db_Seq.valid_Cd;
        usr_Log.valid_Msg = Util.getInstance().getValid_Msg(dBSeq.native_Db_Seq.valid_Cd);
        usr_Log.mode_Ind = dBSeq.mode_Ind;
        usr_Log.change_Ind = dBSeq.change_Ind;
        usr_Log.fldr_Id = dBSeq.fldr_Id;

        usr_Log.url = NavigateUtil.getInstance()
            .getDBSeqUrl(dBSeq.native_Db_Seq.native_Db_Seq_Id, dBSeq.fldr_Id, '');

        return usr_Log;
    }

    updateGridObject(seqGridObject:SeqGridObject, dBSeq: DBSeq): void {
        if (seqGridObject.obj_Id != dBSeq.native_Db_Seq.native_Db_Seq_Id) return;

        seqGridObject.nm = dBSeq.native_Db_Seq.nm;
        seqGridObject.aliasNm = dBSeq.native_Db_Seq.aliasNm;
        seqGridObject.change_Ind = dBSeq.change_Ind;
        seqGridObject.valid_Cd = dBSeq.native_Db_Seq.valid_Cd;
        seqGridObject.imageUrl = dBSeq.imageUrl;
        let databaseWrapper = DatabaseWrappersFactory.getInstance().getDatabaseWrapper(dBSeq.native_Db_Seq.nativeDbTyp_Id);
        seqGridObject.dbTyp_Nm = databaseWrapper.name;
        
        seqGridObject.recExists = dBSeq.recExists;
        seqGridObject.updateBy = dBSeq.native_Db_Seq.updateBy;
        seqGridObject.updateDt = dBSeq.native_Db_Seq.updateDt;
    }

    updateUsr_Log(usr_Log: Usr_Log, dBSeq: DBSeq): void {
        if (usr_Log.obj_Id != dBSeq.native_Db_Seq.native_Db_Seq_Id) return;
        
        usr_Log.nm = dBSeq.native_Db_Seq.nm;
        usr_Log.objectName = "Sequence";
        usr_Log.valid_Cd = dBSeq.native_Db_Seq.valid_Cd;
        usr_Log.valid_Msg = Util.getInstance().getValid_Msg(dBSeq.native_Db_Seq.valid_Cd);
        let imageUrl = 'assets/' + dBSeq.imageUrl.slice(4, dBSeq.imageUrl.length)
        usr_Log.imageUrl = imageUrl;
        usr_Log.mode_Ind = dBSeq.mode_Ind;
        usr_Log.change_Ind = dBSeq.change_Ind;
    }

    copy(dBSeqs: Array<DBSeq>): Array<DBSeq> {
        let dBSeqsTmp: Array<DBSeq> = new Array<DBSeq>();

        for (let i: number = 0; i < dBSeqs.length; i++) {
            let dBSeq: DBSeq = dBSeqs[i] as DBSeq;
            dBSeqsTmp.push(dBSeq.copy())
        }
        return dBSeqsTmp;
    }

    copyFrom(dBSeqs: Array<DBSeq>, dBSeqsTmp: Array<DBSeq>): void {
        let dBSeqsMap: Map<number, DBSeq> = new Map();

        let dBSeqsLength: number = dBSeqs.length;
        for (let i: number = 0; i < dBSeqsLength; i++) {
            dBSeqsMap.set(dBSeqs[i].native_Db_Seq.native_Db_Seq_Id, dBSeqs[i]);
        }

        dBSeqs.splice(0, dBSeqs.length);

        let dBSeqsTmpLength: number = dBSeqsTmp.length;
        for (let i: number = 0; i < dBSeqsTmpLength; i++) {
            let dBSeqTmp: DBSeq = dBSeqsTmp[i] as DBSeq;
            let dBSeq: DBSeq = dBSeqsMap.get(dBSeqTmp.native_Db_Seq.native_Db_Seq_Id);
            if (dBSeq) {
                dBSeq.copyFrom(dBSeqTmp);
            } else {
                dBSeq = DBSeq.parse(dBSeqTmp);
            }

            dBSeqs.push(dBSeq);
        }
    }

    toString(dBSeqs: Array<DBSeq>): string {
        let str: string = '';

        str += 'dBSeqs length: ' + dBSeqs.length + ' ';

        for (var i: number = 0; i < dBSeqs.length; i++) {
            str += dBSeqs[i].toString();
        }

        return str;
    }
}